__turbopack_context__.v({
  "content": "AllDashboards-module-scss-module__UuugDW__content",
  "dashboardCard": "AllDashboards-module-scss-module__UuugDW__dashboardCard",
  "dashboardCardLink": "AllDashboards-module-scss-module__UuugDW__dashboardCardLink",
  "description": "AllDashboards-module-scss-module__UuugDW__description",
  "thumbnail": "AllDashboards-module-scss-module__UuugDW__thumbnail",
  "title": "AllDashboards-module-scss-module__UuugDW__title",
});
